import "./style.scss"

const InfinityProgressBar = ({ type = "secondary" }) => {
  return (
    <div className='container p-0 progress-bar-main'>
      <div className={`progress-bar progress-bar__${type} w-100`}>
        <div
          className={`progress-bar-value progress-bar-value__${type} w-100`}
        />
      </div>
    </div>
  )
}

export default InfinityProgressBar
